import React from 'react';
import Icon from '@pushpay/icon';

const LogoutIcon = props => {
  return /*#__PURE__*/React.createElement(Icon, Object.assign({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.25 16.783c-.46 0-.834.39-.834.87v2.173c0 .24-.186.435-.416.435H4.083a.426.426 0 01-.416-.435V4.174c0-.24.186-.435.416-.435H12c.23 0 .416.195.416.435v2.174c0 .48.374.87.834.87.46 0 .833-.39.833-.87V3.739c0-.96-.746-1.739-1.667-1.739h-8.75C2.747 2 2 2.778 2 3.74v16.52c0 .962.746 1.74 1.667 1.74h8.75c.92 0 1.666-.778 1.666-1.74v-2.608c0-.48-.373-.87-.833-.87zm8.379-5.07l-5-3.48a.812.812 0 00-1.156.242.899.899 0 00-.14.482v2.173h-7.5c-.69 0-1.25.585-1.25 1.305s.56 1.304 1.25 1.304h7.5v2.174c.007.477.376.863.833.87.165 0 .326-.05.463-.146l5-3.479a.892.892 0 00.23-1.206.827.827 0 00-.23-.24z",
    fill: "currentColor"
  }));
};

export default LogoutIcon;